import { APP_RESOURCES_STRATEGY_VS_HOOK } from '@unifyapps/carbon/no-code/components/app/InterfaceAppResourceLoader/constants/resourceStrategyVsHook';
import { useInterfaceResourceStrategy } from '@unifyapps/carbon/no-code/context/InterfaceResourceStrategyProvider';
import { matrixClient, matrixMode } from '../constants';

export function useAppResourceLoading({
  interfaceId,
  locale,
  disableAuth,
}: {
  interfaceId: string;
  locale?: string;
  disableAuth?: boolean;
}) {
  const { strategy } = useInterfaceResourceStrategy();
  const useResourceStrategy = APP_RESOURCES_STRATEGY_VS_HOOK[strategy];

  return useResourceStrategy({
    interfaceId,
    client: matrixClient,
    mode: matrixMode,
    locale,
    disableAuth,
  });
}
